{
  "name": "payee-app",
  "version": "20261021-113105",
  "scripts": {
    "ng": "ng",
    "start:local": "ng serve -c local --host 0.0.0.0 --port 4200 --poll 2000",
    "start:e2e": "ng serve -c e2e --port 4210 --poll 2000",
    "build:prod": "ng build -c production",
    "build:dev": "ng build -c development",
    "build:sandbox": "ng build -c sandbox",
    "watch:local": "ng build --watch -c local",
    "watch": "ng build --watch --configuration local --poll 2000",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular/build": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@fullstory/browser": "^2.0.8",
    "@fullstory/snippet": "2.0.5",
    "@intercom/messenger-js-sdk": "^0.0.14",
    "@lottiefiles/lottie-player": "^2.0.12",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@types/lodash": "^4.17.24",
    "ClientStorage": "^3.0.1",
    "axios": "^1.18.1",
    "clipboard-copy": "^4.0.1",
    "date-fns": "^4.4.0",
    "dijkstrajs": "^1.0.3",
    "handlebars": "^4.7.9",
    "ibantools": "^4.5.4",
    "libphonenumber-js": "^1.13.7",
    "lodash": "^4.18.1",
    "object-to-formdata": "^4.5.1",
    "qrcode": "^1.5.4",
    "remove-accents": "^0.4.4",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zod": "^3.25.76",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/cli": "^21.2.18",
    "@angular/compiler-cli": "^21.2.25",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "1.62.1",
    "@swc/core": "^1.15.43",
    "@types/node": "^22.20.0",
    "@types/qrcode": "^1.5.6",
    "angular-eslint": "^21.4.0",
    "eslint": "^10.6.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jsdom": "^26.1.0",
    "npm": "^12.0.2",
    "playwright-ng-schematics": "^21.1.1",
    "prettier": "^3.9.4",
    "source-map": "^0.7.6",
    "ts-node": "~8.3.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.62.1",
    "vitest": "^4.1.9"
  },
  "peerDependencies": {
    "@fullstory/snippet": "2.0.5"
  }
}